import ChestIconPath from '@/assets/map/chest.png';
import DeathIconPath from '@/assets/map/death.png';
import EnemyIconPath from '@/assets/map/enemy.png';
import GateIconPath from '@/assets/map/gate.png';
import NPCIconPath from '@/assets/map/npc.png';
import PuzzleIconPath from '@/assets/map/puzzle.png';
import QuestIconPath from '@/assets/map/quest.png';
import ShopIconPath from '@/assets/map/shop.png';
import StairsIconPath from '@/assets/map/stairs.png';
import TrapIconPath from '@/assets/map/trap.png';

/**
 * Which file a marker draws. The backend's label catalog names the marker;
 * this is the only place that turns that name into a picture, so the map and
 * the label picker can never disagree about what a marker looks like.
 */
const ROOM_ICON_PATHS = {
    chest: ChestIconPath,
    death: DeathIconPath,
    enemy: EnemyIconPath,
    gate: GateIconPath,
    npc: NPCIconPath,
    puzzle: PuzzleIconPath,
    quest: QuestIconPath,
    shop: ShopIconPath,
    stairs: StairsIconPath,
    trap: TrapIconPath,
};

const preloaded = {};

/**
 * The URL of a marker's icon, for an <img> tag. Null when the marker draws
 * nothing, which is the normal case for "regular".
 */
export function roomIconUrl(marker) {
    return ROOM_ICON_PATHS[marker] || null;
}

/**
 * The same icon as a loaded HTMLImageElement, for canvas and SVG drawing.
 * Images are created once per marker and reused.
 */
export function roomIconImage(marker) {
    const path = roomIconUrl(marker);
    if (!path) {
        return null;
    }
    if (!preloaded[marker]) {
        const image = new Image();
        image.src = path;
        preloaded[marker] = image;
    }
    return preloaded[marker];
}

export {ROOM_ICON_PATHS};
